<template>
  <el-collapse-item
    title="Personal Info"
    name="demographics"
  >
    <p>
      <strong>Gender: </strong>
      {{ user.gender | NA | ucwords }}
    </p>
    <p>
      <strong>Date of Birth: </strong>
      {{ birthDate(user.birthInfo.day, user.birthInfo.month, user.birthInfo.year) }}
    </p>
    <p>
      <strong>Education Level: </strong>
      {{ user.educationLevel | NA | removeDashes | ucwords }}
    </p>
    <p>
      <strong>Location: </strong>
      {{ (user.location && user.location.name) | NA | ucwords }}
    </p>
    <p>
      <strong>Employment Status: </strong>
      {{ user.employmentStatus | NA | removeDashes | ucwords }}
    </p>

    <p v-if="user.resetKey">
      <strong>Reset Password Link: </strong>
      <el-button type="text" @click="copyResetUrl"><i class="el-icon-link el-icon-left"></i>Copy</el-button>
    </p>

    <p v-else>
      <strong>Reset Password Link: </strong>
      <i>User has not requested a new password</i>
    </p>

    <el-row v-if="user.progress">
      <el-col :span="4">
        <strong>Progress:</strong>
      </el-col>
      <el-col :span="20">
        <el-progress
          :text-inside="true"
          :stroke-width="15"
          :percentage="user.progress > 100 ? 100 : user.progress "
        />
      </el-col>
    </el-row>

    <section
      v-loading="assessments.loading"
      class="drawer-panel-section assessment-graphic"
      :class="{
        'assessment-graphic__loading': assessments.loading,
        'assessment-graphic__no-results': !assessments.data.length && !assessments.loading
      }"
    >
      <radar
        v-if="assessments.data.length"
        :chart-data="assessments.data"
        height="300"
      />
    </section>
  </el-collapse-item>
</template>

<script>
import Radar from '@/components/Charts/Radar/Radar'
import axios from '@/axios/axios'

export default {
  name: 'Demographics',
  components: {
    Radar
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      assessments: {
        data: [],
        loading: false
      }
    }
  },
  created() {
    this.getUserAssessments()
  },
  methods: {
    copyResetUrl() {
      const dummy = document.createElement('input')
      document.body.appendChild(dummy)
      dummy.value = 'https://dashboard.owiwi.co.uk/reset-password?key=' + this.user.resetKey
      dummy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy)

      this.successNotification('URL copied!')
    },
    getUserAssessments() {
      this.assessments.loading = true

      return axios.get('assessment/user', {
        params: {
          userId: this.user.id
        }
      })
        .then(res => {
          this.assessments.data = res.data
          this.assessments.loading = false
        })
        .catch(axios.handleError)
    }
  }
}
</script>

<style lang="scss" scoped>
  .assessment-graphic {
    transition: all 0.3s;
  }

  .assessment-graphic__loading {
    height: 100px;
  }

  .assessment-graphic__no-results {
    height: 0;
  }
</style>
